
import Vue from 'vue'

import Plant from '@/models/Plant'
import Image from '@/models/Image'

import PlantAvatar from '@/ui/components/plants/PlantAvatar.vue'
import JImageGallery from '@/ui/controls/JImageGallery.vue'

import { sortItemsByTimestampsDesc } from '@/helpers/sorters'
import Harvest from '@/models/Harvest'
import { id } from '@/types/models'
import { formatLongDate } from '@/helpers/formatters'

export default Vue.extend({
  components: {
    PlantAvatar,
    JImageGallery,
  },
  props: {
    // gardenId: String,
    plantId: String,
    harvestId: String,
  },
  data: () => ({
    deleting: false,
  }),
  computed: {
    plant(): Plant | undefined {
      return this.harvest?.plant
    },
    // plantId(): id | undefined {
    //   return this.harvest?.plantId
    // },
    harvest(): Harvest | undefined {
      // return this.plant.harvests.find((h: Harvest) => h.id === this.harvestId)
      return this.$store.getters['gardens/plants/harvests/find'](this.harvestId)
    },
    sortedImages(): Array<Image> {
      return this.harvest?.images.slice().sort(sortItemsByTimestampsDesc) || []
    },
  },
  methods: {
    formatLongDate: formatLongDate,
    deleteWithPrompt() {
      if (window.confirm('Do you really want to delete this harvest?')) {
        this.delete(
          this.plant?.gardenId || 'error',
          this.plant?.id || 'error',
          this.harvestId
        )
      }
    },
    delete(gardenId: id, plantId: id, harvestId: id) {
      this.deleting = true
      this.$store
        .dispatch('gardens/plants/harvests/delete', {
          gardenId,
          plantId,
          harvestId,
        })
        .then(() =>
          this.$store.dispatch('snackbars/success', `Deleted harvest!`)
        )
        .then(() => this.$emit('close'))
        .catch((err: Error) =>
          this.$store.dispatch('snackbars/error', err.message)
        )
        .finally(() => (this.deleting = false))
    },
  },
})
